export default function (num) {
  const number = num.split(',');

  return `${number[0]},${number[1].sup()}`;
}
